module.exports = __webpack_public_path__ + "static/media/empty_transactions.57488138.png";